<template>
    <select v-model="claimCosts">
        <option value="all">All</option>
        <option value="damages">Damages</option>
        <option value="claimantCosts">Claimant Costs</option>
        <option value="defenceCosts">Defence Costs</option>
    </select>
</template>

<script>
    export default {
        name: 'claim-costs',
        computed: {
            claimCosts: {
                get() {
                    return this.$store.getters['dashboards/claimCost'];
                },
                set(value) {
                    this.$store.dispatch('dashboards/updateFilter', {filter: 'claimCost', value})
                },
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimCosts.vue?e951e87a